import {
    SelectOptionsServiceGetCitiesResult,
    SelectOptionsServiceGetConnectFlowsResult,
    SelectOptionsServiceGetConnectFlowAudiosResult,
    SelectOptionsServiceGetConnectFlowCustomsResult,
    SelectOptionsServiceGetConnectFlowQueuesResult,
    SelectOptionsServiceGetConnectFlowSchedulesResult,
    SelectOptionsServiceGetConnectFlowSurveysResult,
    SelectOptionsServiceGetContactPhoneNumbersResult,
    SelectOptionsServiceGetLevelsResult,
    SelectOptionsServiceGetMediasResult,
    SelectOptionsServiceGetNumbersResult,
    SelectOptionsServiceGetRolesResult,
    SelectOptionsServiceGetUsersResult,
    SelectOptionsServiceGetUserExtensionsResult,
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetWordsResult,
    SelectOptionsServiceGetQueuesResult,
} from '@/types';
import BaseService from '@/services/api/BaseService';
import { AxiosRequestConfig } from 'axios';

class SelectOptionsService extends BaseService<unknown> {
    getCities(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetCitiesResult[]>(`${this.route}/cities`, config);
    }

    getConnectFlows(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowsResult[]>(
            `${this.route}/connect-flows`,
            config,
        );
    }

    getConnectFlowAudios(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowAudiosResult[]>(
            `${this.route}/connect-flow-audios`,
            config,
        );
    }

    getConnectFlowCustoms(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowCustomsResult[]>(
            `${this.route}/connect-flow-customs`,
            config,
        );
    }

    getConnectFlowQueues(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowQueuesResult[]>(
            `${this.route}/connect-flow-queues`,
            config,
        );
    }

    getConnectFlowSchedules(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowSchedulesResult[]>(
            `${this.route}/connect-flow-schedules`,
            config,
        );
    }

    getConnectFlowSurveys(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetConnectFlowSurveysResult[]>(
            `${this.route}/connect-flow-surveys`,
            config,
        );
    }

    getContactPhoneNumbers(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetContactPhoneNumbersResult[]>(
            `${this.route}/contact-phone-numbers`,
            config,
        );
    }

    getLevels(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetLevelsResult[]>(`${this.route}/levels`, config);
    }

    getMedias(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetMediasResult[]>(`${this.route}/medias`, config);
    }

    getNumbers(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetNumbersResult[]>(
            `${this.route}/numbers`,
            config,
        );
    }

    getQueues(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetQueuesResult[]>(`${this.route}/queues`, config);
    }

    getRoles(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetRolesResult[]>(`${this.route}/roles`, config);
    }

    getUsers(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetUsersResult[]>(`${this.route}/users`, config);
    }

    getUserExtensions(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetUserExtensionsResult[]>(
            `${this.route}/user-extensions`,
            config,
        );
    }

    getUserLabels(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetUserLabelsResult[]>(
            `${this.route}/user-labels`,
            config,
        );
    }

    getWords(config?: AxiosRequestConfig) {
        return this.http.get<SelectOptionsServiceGetWordsResult[]>(`${this.route}/words`, config);
    }
}

export default new SelectOptionsService('select-options');
